<template>
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1611 1.02051C11.5042 0.325642 12.4944 0.327766 12.8389 1.01953V1.02051L15.7686 6.95996L15.8848 7.19531L16.1445 7.2334L22.6982 8.18848H22.6992C23.4161 8.29253 23.7317 9.12985 23.3105 9.67969L23.2158 9.78516L18.4746 14.4062L18.2861 14.5898L18.3301 14.8486L19.4521 21.376C19.5824 22.1404 18.7755 22.7178 18.0957 22.3604L12.2324 19.2783L12 19.1562L11.7676 19.2783L5.9043 22.3604L5.90234 22.3613C5.22606 22.7195 4.41711 22.1433 4.54785 21.376L5.66992 14.8486L5.71387 14.5898L5.52539 14.4062L0.78418 9.78516L0.689453 9.67969C0.268262 9.12985 0.583942 8.29253 1.30078 8.18848H1.30176L7.85547 7.2334L8.11523 7.19531L8.23145 6.95996L11.1611 1.02051Z"
      stroke-width="2"
    />
  </svg>
</template>
